import { atom, useAtom } from 'jotai';
import { TurnaroundOriginForm } from '../models';

const turnaroundDestinationForm = atom<TurnaroundOriginForm>({
  // NOTE: supplier is shared between origin and destination forms
  orderNumber: '',
  surgeryReference: '',
  deliveryNumber: '',
  surgeon: null,
  surgeryDate: undefined,
});

export const useTurnaroundDestinationForm = () => useAtom(turnaroundDestinationForm);
